module.exports = __webpack_public_path__ + "img/1-1.9c18c916.svg";